// extracted by mini-css-extract-plugin
var _1 = "styles_announcement__siMGj";
var _2 = "styles_container__3PRW+";
var _3 = "styles_message__W4UJx";
var _4 = "styles_updateButton__Ti0zO";
export { _1 as "announcement", _2 as "container", _3 as "message", _4 as "updateButton" }
